// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-question-names-editor {
  width: 90%;
}
.fi-form-question-names-editor .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-form/form-question-names-editor/form-question-names-editor.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAAI;EACI,WAAA;AAER","sourcesContent":[".fi-form-question-names-editor {\r\n    width: 90%;\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
